<template>
  <div class="card border-1">
    <div class="table-container">
      <table width="100%" class="table create-billing table-width">
        <thead>
          <tr class="bg-black-light">
            <td class="font-medium-1 p-25" colspan="100%">{{ tableTitle }}</td>
          </tr>
          <tr>
            <th>#</th>
            <th colspan="5">Item Description</th>
            <th>Qty</th>
            <th>Rate</th>
            <th>Amount</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody ref="tableRef">
          <DirectComponentItem
              v-for="(item, i) in tableItems"
              :key="i"
              :item="item"
              :index="i"
              @onDeleteItem="onDeleteItem"
          />
          <tr>
            <td colspan="4">
              <button @click="addNewItem" class="btn btn-outline-primary btn-sm input-group-text">
                <i class="fas fa-plus"></i>
                Add new
              </button>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <th colspan="" class="text-center">Total</th>
            <th class="text-center">{{ getTotal }}</th>
          </tr>
        </tbody>
      </table>
      <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
import {computed} from 'vue';
import DirectComponentItem from '@/components/molecule/company/inventory/product-costing/DirectComponentItem.vue'

const props = defineProps({
  tableTitle: {
    type: String
  },
  tableItems: {
    type: Array
  },
  type: {
    type: String,
    default:'direct_labor'
  }
})

const getTotal = computed(() => {
  return props.tableItems.reduce((total, amount) => total + parseFloat(amount.amount), 0).toFixed(4);
})

const addNewItem = () => {
  props.tableItems.push({
    for_total_cost: true,
    id: null,
    product: null,
    product_costingable_id: null,
    product_costingable_type: 'App\\Models\\AccountHead',
    quantity: 1,
    rate: 0,
    amount: 0,
    type: props.type
  })
}

const onDeleteItem = (index) => {
  props.tableItems.splice(index, 1);
}
</script>

<style>
.create-billing > :not(first-child) > * {
  padding-left: 10px !important;
}

.create-billing > :not(caption) > * > * {
  padding: 0.72rem 0.2rem;
}

</style>
